import React, { useMemo } from 'react';
import { MenuItem } from '../../../models/MenuItem';
import { cleanLink } from '../../../shared/cleanLink';
import { useMainMenuData } from './useMainMenuData';
import { MainMenuSubMenu } from './MainMenuSubMenu';
import './FooterMenu.scss';

export const FooterMenu = () => {
    const { parentItems, footerSitesItems } = useMainMenuData();

    const items: MenuItem[] = useMemo(() => {
        return [
            ...parentItems,
            {
                id: `footer-sites-cat`,
                url: ``,
                title: `Spectrum Sites`,
                enabled: true,
                weight: `100`,
                menu_name: ``,
                childrenMenuItems: footerSitesItems,
            },
        ];
    }, [parentItems, footerSitesItems]);

    return (
        <nav className="footer-menu kite-container">
            {items.map((item) => {
                const titleId = `menu-footer-${cleanLink(item.title)}`;
                return (
                    <section className="category" key={`fs-${item.id}`}>
                        <p className="typestack-body-2" id={titleId}>
                            {item.title}
                        </p>
                        <MainMenuSubMenu
                            items={item.childrenMenuItems}
                            title={item.title}
                            titleId={titleId}
                            footer={true}
                        />
                    </section>
                );
            })}
        </nav>
    );
};
